import React from 'react';
import { motion } from 'framer-motion';
import { Skeleton } from '@/components/ui/skeleton';

interface PageCardSkeletonProps {
  index?: number;
}

const PageCardSkeleton: React.FC<PageCardSkeletonProps> = ({ index = 0 }) => {
  return (
    <motion.div 
      className="group relative cursor-pointer transition-all duration-300 ease-in-out hover:scale-[1.02] hover:shadow-xl hover:shadow-purple-100/30 dark:hover:shadow-purple-900/20"
      initial={{ opacity: 0 }}
      animate={{ 
        opacity: 1,
        transition: {
          duration: 0.3,
          delay: index * 0.02
        }
      }}
      style={{ 
        transform: 'translateZ(0)',
        backfaceVisibility: 'hidden',
        willChange: 'transform',
        transformStyle: 'preserve-3d'
      }}
    >
      {/* Modern card with glass morphism effect */}
      <div className="relative bg-white/80 dark:bg-gray-900/80 backdrop-blur-xl border border-white/20 dark:border-gray-700/30 rounded-2xl p-6 h-full shadow-lg transition-all duration-300">
        {/* Top accent stripe */}
        <div className="absolute top-0 left-0 right-0 h-0.5 bg-gradient-to-r from-red-400/50 to-orange-400/50 rounded-t-2xl" />
        
        {/* Header with edit button */}
        <div className="flex items-start justify-between mb-4">
          {/* Title skeleton */}
          <div className="flex-1 space-y-2">
            <Skeleton className="h-5 w-3/4" />
            <Skeleton className="h-5 w-1/2" />
          </div>
          
          {/* Edit button skeleton */}
          <Skeleton className="h-8 w-8 rounded-lg ml-3" />
        </div>
        
        {/* Metadata line - simplified */}
        <div className="mb-4">
          <Skeleton className="h-3 w-32" />
        </div>
        
        {/* Footer - simplified */}
        <div className="flex items-center justify-between mt-auto pt-4 border-t border-gray-200/50 dark:border-gray-700/50">
          <Skeleton className="h-4 w-24 rounded-full" />
          <Skeleton className="h-6 w-20 rounded-md" />
        </div>
      </div>
    </motion.div>
  );
};

export default PageCardSkeleton;